import { MembershipResponse, Persona } from '../types/data.types';

export const getBenefitsFromPersona = (
  { personas }: Persona
) => (personas && personas?.length > 0 ? personas[0].benefits?.travelBenefits : null);

export const getTopCard = (
  membership: MembershipResponse[]
) => membership?.filter((account: MembershipResponse) => account.demographics.isTopCard)[0];
